import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../../api";

export const LIST_DOCUMENTS_QUERY_KEY = "listDocuments";

export const useListDocuments = () => {
  const client = useApiClient();

  return useQuery({
    queryKey: [LIST_DOCUMENTS_QUERY_KEY],
    queryFn: () => client.api.listDocuments(),
    select(data) {
      return data.data;
    },
  });
};
